/**
 * RESPONSIBILITY: which sections make up the Leadership page, and in what order.
 */
import { SectionName } from '@app/sections';
import { SectionUpdate } from '../cms';
import {
  Crumbs, LeadershipHero, PastorsNote, Pillars, LeadershipTeam, Reveal, Page, hrefFor,
  useWords,
} from '../site';

export function LeadershipPage() {
  const w = useWords();

  return (
    <main>
      <Crumbs trail={[{ label: w.aboutLabel }, { label: w.leadershipLabel }]} />

      {/* Its own band rather than the shared PageHead: this page opens on words over the
          brand colour, and the portraits that matter are further down. */}
      <SectionUpdate name={SectionName.LeadershipHero}>
        {(c) => <LeadershipHero c={c} />}
      </SectionUpdate>

      <SectionUpdate name={SectionName.LeadershipNote}>
        {(c) => <Reveal><PastorsNote c={c} /></Reveal>}
      </SectionUpdate>

      <SectionUpdate name={SectionName.LeadershipPillars}>
        {(c) => <Reveal><Pillars c={c} /></Reveal>}
      </SectionUpdate>

      <SectionUpdate name={SectionName.LeadershipTeam}>
        {(c) => <Reveal><LeadershipTeam c={c} /></Reveal>}
      </SectionUpdate>

      <SectionUpdate name={SectionName.LeadershipVisit}>
        {(c) => (
          <Reveal>
          <section className="band band-sand band-centre">
            <div className="wrap">
              <h2>{c.heading}</h2>
              {c.body && <p className="lede">{c.body}</p>}
              <div className="btns btns-centre">
                <a className="btn btn-ghost" href={c.ctaHref || hrefFor(Page.Contact)}>
                  {c.ctaLabel}
                </a>
              </div>
            </div>
          </section>
          </Reveal>
        )}
      </SectionUpdate>
    </main>
  );
}
